export const name = "signal";
